import { ThreadItem } from '@/models/thread';
import { FC, ReactNode } from 'react';
import { ItemContext } from './ItemContext';

interface ItemProviderProps {
  item: ThreadItem;
  isLast: boolean;
  children: ReactNode;
}
export const ItemProvider: FC<ItemProviderProps> = ({
  item: block,
  isLast,
  children,
}) => {
  return (
    <ItemContext.Provider value={{ item: block, isLast }}>
      {children}
    </ItemContext.Provider>
  );
};
